/**
 * @generated SignedSource<<0024c1b26cc99ca495e3cb88fbccde47>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type discountCodeCodesTableHeader_DiscountActionFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"discountCodeCreateRandom_DiscountActionFragment" | "discountCodeCreateSingle_DiscountActionFragment" | "discountCodeDownloadCsvButton_DiscountActionFragment">;
  readonly " $fragmentType": "discountCodeCodesTableHeader_DiscountActionFragment";
};
export type discountCodeCodesTableHeader_DiscountActionFragment$key = {
  readonly " $data"?: discountCodeCodesTableHeader_DiscountActionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"discountCodeCodesTableHeader_DiscountActionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "discountCodeCodesTableHeader_DiscountActionFragment",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "discountCodeCreateRandom_DiscountActionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "discountCodeCreateSingle_DiscountActionFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "discountCodeDownloadCsvButton_DiscountActionFragment"
    }
  ],
  "type": "DiscountAction",
  "abstractKey": null
};

(node as any).hash = "7c9f1cf541c7a47b8b63e5d8e6787f27";

export default node;
